const _ = require('lodash')

function init(modules, config, el, message){
    console.log('Mouse Event Handler Package Init')
    
    let ioc = modules.ioc
    let schemeSetting = ioc.run('3r/schemeSettings/webapp')
    let realDevice = modules.Device
    let packageConfig = schemeSetting.globals.mouseEventHandlerPackage
    console.log('Package Config : ', packageConfig)
    
    packageConfig && packageConfig.eventsConfig.forEach((eventConfig, index)=> {
        let repeat = eventConfig.repeat
        let delay = eventConfig.delay || 0
        let selector = eventConfig.selector
        let targetElement = document
        let mouseEnterisTriggred = _.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseEnter") || false
        let mouseLeaveisTriggred = _.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseLeave") || false
        
        realDevice.on('user', (user) => {
            if(_.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseEnter")){
                mouseEnterisTriggred = _.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseEnter")
            }
            
            if(_.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseLeave")){
                mouseLeaveisTriggred = _.get(realDevice.variables, "mouseEventHandlerPackage["+index+"].mouseLeave")
            }
        })
        
        if(selector){
            targetElement = document.querySelector(selector)
        }
        if(targetElement){
            targetElement.addEventListener('mouseenter', () => {
                if(repeat){
                    mouseEnterisTriggred = false
                }
                if(!mouseEnterisTriggred){
                    setTimeout(()=>{
                        console.log('Mouse Enter')
                        let mouseEnterUnlock = eventConfig.mouseEnter.unlock.code
                        let mouseEnterUnlockPacket = eventConfig.mouseEnter.unlock.packet
                        let mouseEnterNavigate = eventConfig.mouseEnter.navigate
                        if(mouseEnterUnlock){
                            realDevice.unlock(mouseEnterUnlock, mouseEnterUnlockPacket)
                        }
                        
                        if(mouseEnterNavigate){
                            let vvm = ioc.run('3r/vvm/vvm')
                            vvm.navigateTo(mouseEnterNavigate)
                        }
                        
                        realDevice.canUpdateData(async () => {
                            let variables = realDevice.variables || {}
                            _.set(variables, "mouseEventHandlerPackage.["+index+"].mouseEnter" , true)
                            await realDevice.updateVariables()
                            await realDevice.getInfo()
                        })
                    
                    }, delay)
                }
            })
            
            targetElement.addEventListener('mouseleave', () => {
                if(repeat){
                    mouseLeaveisTriggred = false
                }
                if(!mouseLeaveisTriggred){
                    setTimeout(()=>{
                        console.log('Mouse Leave')
                        let mouseLeaveUnlock = eventConfig.mouseLeave.unlock.code
                        let mouseLeaveUnlockPacket = eventConfig.mouseLeave.unlock.packet
                        let mouseLeaveNavigate = eventConfig.mouseLeave.navigate
                        if(mouseLeaveUnlock){
                            realDevice.unlock(mouseLeaveUnlock, mouseLeaveUnlockPacket)
                        }
                        
                        if(mouseLeaveNavigate){
                            let vvm = ioc.run('3r/vvm/vvm')
                            vvm.navigateTo(mouseLeaveNavigate)
                        }
                        
                        realDevice.canUpdateData(async () => {
                            let variables = realDevice.variables || {}
                            _.set(variables, "mouseEventHandlerPackage.["+index+"].mouseLeave" , true)
                            await realDevice.updateVariables()
                            await realDevice.getInfo()
                        })
                    
                    },delay)
                }
            })
        }
    }) 
}


window['mouseEventHandlerPackage'] = {
  init : init
}